import { useState } from 'react';

// material-ui
import { Box, FormControl, InputAdornment, OutlinedInput, IconButton } from '@mui/material'

// assets
import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons'

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

var timer = null

const Search = ({ search, initvalue, searchHint }) => {
  const [value, setValue] = useState(initvalue);

  const dataChange = (data) => {
    setValue(data)
    if (timer != null) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      search(data)
      timer = null
    }, 300)
  }

  return (
    <Box >
      <FormControl sx={{ width: { xs: '100%', md: 320 } }}>
        <OutlinedInput
          size="small"
          id="header-search"
          startAdornment={
            <InputAdornment position="start" sx={{ mr: -0.5 }}>
              <SearchOutlined />
            </InputAdornment>
          }
          endAdornment={value != '' &&
            <IconButton sx={{ mr: -1.5 }}
              aria-label="toggle password visibility"
              onClick={() => dataChange("")}
            ><CloseCircleOutlined /></IconButton>
          }
          aria-describedby="header-search-text"
          inputProps={{
            'aria-label': 'weight'
          }}
          placeholder={searchHint ? searchHint : "Search.."}
          value={value}
          onChange={(e) => {
            dataChange(e.target.value)
          }}
        />
      </FormControl>
    </Box>
  )
}

export default Search
